<template>
  <div class="company-profile-container">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
          <div class="container-fluid company-profile-wrapper">
            <home-title title="COMPANY PROFILE" subTitle="公司简介" />
            <div class="row company-info-wrapper">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 company-info-text">
                <p>
                  广州市同慧信息科技有限公司是一间一直专注于行政事业单位的软件信息系统服务的公司，包括自主开发财务系统和资产内控管理系统，包括自主开发财务系统和资产内控管理系统，也为广州市本级，广东省本级，天河区和从化区本级的部分客户提供财政系统技术支持与业务咨询服务。公司统一社会信用代码为91440101MA59M68875，成立于2017年。
                </p>
                <p>
                  2019年在惠州市全市法院案款改革中，惠州市中院和下级法院都采用我公司案款财务系统记账，并为全市法院财务系统连通省法案执行款系统提供技术服务，实现对执行案款的无缝链接，同时惠州市也成为广东省法院系统执行款改革试点。目前在惠州，河源，清远，潮州饶平，茂名，广州等法院上线运行。
                </p>
              </div>
            </div>
            <div class="row company-info-wrapper">
              <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 company-info-item">
                <img src="../assets/company/system.png" alt="系统建设" />
                <p class="content-title">系统建设</p>
                <p class="content-text">专业财政财务信息管理、信息化建设架构体系，为您量身定制。</p>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 company-info-item">
                <img src="../assets/company/service.png" alt="决算服务" />
                <p class="content-title">决算服务</p>
                <p class="content-text">还在为决算数据烦恼吗？ 我们提供完善的决算服务。</p>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 company-info-item">
                <img src="../assets/company/counselor.png" alt="顾问服务" />
                <p class="content-title">顾问服务</p>
                <p class="content-text">可为您单位提供全面的财务问题，单位内控问题等专业的咨询服务。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <home-title title="PRODUCT INTRODUCTION" subTitle="公司资质" />
        <swiper-comp />
      </div>
    </div>
    <img src="../assets/company/banner.png" alt="" />
  </div>
</template>
<script>
import HomeTitle from "@/components/home/homeItemTitle.vue";
import CertificateComp from "../components/product/CertificateComp.vue";
export default {
  name: "CompanyProfile",
  components: {
    HomeTitle,
    CertificateComp,
  },
};
</script>
<style scoped>
.company-profile-container {
  padding-left: 0;
  padding-right: 0;
}
.company-profile-container > img {
  width: 100%;
}
.company-profile-wrapper {
  padding-top: 24px;
  padding-bottom: 30px;
}
.company-info-wrapper {
  padding: 20px 62px 0 62px;
}
.company-info-text {
  font-size: 14px;
  color: #000000;
}
.company-info-text > p {
  margin-bottom: 20px;
  line-height: 24px;
}
.company-info-item {
  text-align: center;
}
.company-info-item > img {
  width: 50px;
  height: 50px;
}
.company-info-item > p.content-title {
  font-size: 14px;
  color: #333333;
  margin-top: 6px;
}
.company-info-item > p.content-text {
  font-size: 12px;
  color: #424242;
  margin-top: 10px;
  line-height: 18px;
}
@media (min-width: 768px) {
  .company-info-wrapper {
    display: flex;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/companyProfile.vue